import React from 'react';
import './Team.css';

const Team = ({ team, rank, isClassified, animationDelay = 0 }) => (
  <tr
    className={`team-row ${isClassified ? 'team-row--classified' : ''}`.trim()}
    style={{ animationDelay: `${animationDelay}s` }}
  >
    <td className="team-row__rank">{rank}</td>
    <td className="team-row__name">{team.name}</td>
    <td>{team.played}</td>
    <td>{team.won}</td>
    <td>{team.drawn}</td>
    <td>{team.lost}</td>
    <td>{team.points}</td>
    <td>{team.goalDifference}</td>
  </tr>
);

export default Team;
